/**
 * Maps properties of each result to props
 * of its associated component. This ensures
 * that only props expected by the component are bound to it.
 * Otherwise, Vue would automatically add the unrecognised props
 * as HTML attributes, polluting the markup.
 * @param {Iterable} results
 * @returns {Iterator}
 */
export default function* withProps(results) {
  for (const { component, result } of results) {
    const { props } = component;
    if (!props) {
      yield { result, component, props: {} };
      continue;
    }

    const mappedProps = Object.keys(props).reduce((attrs, propName) => {
      if (result[propName]) {
        attrs[propName] = result[propName];
      } else if (propName === 'source') {
        // TODO: simplify this either by renaming `displayUrl` in common proto
        // or renaming the `source` prop
        attrs.source = result.displayUrl;
      }
      return attrs;
    }, {});

    yield { result, component, props: mappedProps };
  }
}
